import(/* webpackMode: "eager", webpackExports: ["MainColumn"] */ "/home/runner/actions-runner/_work/cocreation-front/cocreation-front/app/components/MainColumn.tsx");
